import { useAdminApi } from "../../../../common/api/admin-api/useAdminApi";
import { useOrdersAirlineApi } from "../../../../common/api/orders-api/airline/useOrdersAirlineApi";

export const useAdminAirlineApi = () => {
    const { getAirlineList, syncAirlines } = useAdminApi();
    const {
        addSystemPlatform,
        removeSystemPlatform,
        updateSpecification,
        validateSystem,
        updateEncodeConfiguration,
        updateDeliveryInfo,
        updateBuzzIds,
        updateShreqIds,
        getSystemPlatformsList,
        getSystemPlatformDetails
    } = useOrdersAirlineApi();

    return {
        getAirlineList,
        syncAirlines,
        addSystemPlatform,
        removeSystemPlatform,
        updateSpecification,
        validateSystem,
        updateEncodeConfiguration,
        updateDeliveryInfo,
        updateBuzzIds,
        updateShreqIds,
        getSystemPlatformsList,
        getSystemPlatformDetails
    };
};
